import PopupWithForm from '../../PopupWithForm/PopupWithForm.jsx';
import { slugToText } from '../../../utils/slugify.js';

function DeleteNotePopup({ isOpen, onClose, onDelete, note }) {
  return (
    <PopupWithForm
      isOpen={isOpen}
      onClose={onClose}
      name="delete-note"
      title="Note Deletion"
      buttonText=""
      isButtonEnabled={true}
      onSubmit={(e)=> {
        e.preventDefault();
        onDelete(note)
      }}
    >
      <p>Do you confirm deleting your notes on lesson:</p>
      <strong>{slugToText(note?.videoSlug)}</strong>
      <div className="popup__confirm-buttons" style={{ marginTop: "1rem", display: "flex", gap: "1rem", justifyContent: "center" }}>
        <button type="button" className="popup__button" onClick={(e) => {
          e.preventDefault();
          onDelete(note);
        }} >
          Delete
        </button>
        <button type="button" className="popup__button popup__button_cancel" onClick={onClose}>
          Exit
        </button>
      </div>
    </PopupWithForm>
    
  )
}

export default DeleteNotePopup;